class UtilForm {

    /**
     * Clears a file input. In older browsers, the input needs to be cloned for this. In that case, we return the cloned node so it can be re-initializedif necessary. Otherwise null is returned
     * @return Node Returns t 
     */
    static clearFileInput(fileInput) {
        try {
            fileInput.value = null;
        } catch(ex) {
            //ignore errror
        }
        if (fileInput.value) {
            clonedInput = fileInput.cloneNode(true);
            fileInput.parentNode.replaceChild(clonedInput, fileInput);
            return clonedInput;
        }
        return null;
      }
}

export {UtilForm};